import { createApp } from 'vue'
import App from './App.vue'
import { createVisualGameAdminClient } from './api/client.js'
import { configureGenerationRecordsHttp } from './api/generation-records.js'
import { configureAnalyticsHttp } from './api/analytics.js'
import { configureLlmAdminHttp } from './api/llm/index.js'
import { configureAdminWaitlistHttp } from './api/waitlist.js'
import { configureAdminUsersHttp } from './api/users.js'
import { configureUsageHttp } from './api/usage.js'
import { configureModelCapabilityHttp } from './api/model-capabilities.js'
import { configureIntentVideoHttp } from './api/intent-videos.js'
import { configureAssetLibraryHttp } from './api/asset-library.js'
import { configurePromptLibraryHttp } from './api/prompt-library.js'
import { configureEntityLibraryHttp } from './api/entity-library.js'
import { configureCreatorProjectsHttp } from './api/creator-projects.js'
import { configureScenarioReleaseHttp } from './api/scenario-releases.js'
import { configureHomepageCarouselHttp } from './api/homepage-carousel.js'
import { configureHomepagePopularPinsHttp } from './api/homepage-popular-pins.js'
import { createAdminAuth, adminAuthKey } from './composables/useAdminAuth.js'
import { createAdminI18n } from './i18n/index.js'
import { createAdminRouter } from './router/index.js'
import { installAdminTheme } from './composables/useAdminTheme.js'
import '@drama/ui/theme.css'
import './styles/base.css'

const baseUrl = /** @type {any} */ (import.meta).env?.VITE_API_BASE_URL ?? '/'
const initialLocale = /** @type {any} */ (import.meta).env?.VITE_LOCALE ?? 'zh'

// 上次选的明暗;没选过跟系统。挂载前落到 DOM 上,页面不会先闪一下另一套色。
installAdminTheme()

const i18n = createAdminI18n({ locale: initialLocale })
const api = createVisualGameAdminClient({
  baseUrl,
  getLocale: () => i18n.getLocale(),
})
configureAdminWaitlistHttp({
  baseUrl,
  tokenStore: api.tokenStore,
  getLocale: () => i18n.getLocale(),
})
configureAdminUsersHttp({
  baseUrl,
  tokenStore: api.tokenStore,
  getLocale: () => i18n.getLocale(),
})
configureAnalyticsHttp({ baseUrl, tokenStore: api.tokenStore, getLocale: () => i18n.getLocale() })
configureGenerationRecordsHttp({
  baseUrl,
  tokenStore: api.tokenStore,
  getLocale: () => i18n.getLocale(),
})
configureUsageHttp({
  baseUrl,
  tokenStore: api.tokenStore,
  getLocale: () => i18n.getLocale(),
})
configureModelCapabilityHttp({
  baseUrl,
  tokenStore: api.tokenStore,
  getLocale: () => i18n.getLocale(),
})
configureIntentVideoHttp({
  baseUrl,
  tokenStore: api.tokenStore,
  getLocale: () => i18n.getLocale(),
})
configureAssetLibraryHttp({
  baseUrl,
  tokenStore: api.tokenStore,
  getLocale: () => i18n.getLocale(),
})
configurePromptLibraryHttp({
  baseUrl,
  tokenStore: api.tokenStore,
  getLocale: () => i18n.getLocale(),
})
configureEntityLibraryHttp({
  baseUrl,
  tokenStore: api.tokenStore,
  getLocale: () => i18n.getLocale(),
})
configureCreatorProjectsHttp({ baseUrl, tokenStore: api.tokenStore, getLocale: () => i18n.getLocale() })
configureScenarioReleaseHttp({ baseUrl, tokenStore: api.tokenStore, getLocale: () => i18n.getLocale() })
configureHomepageCarouselHttp({ baseUrl, tokenStore: api.tokenStore, getLocale: () => i18n.getLocale() })
configureHomepagePopularPinsHttp({ baseUrl, tokenStore: api.tokenStore, getLocale: () => i18n.getLocale() })
configureLlmAdminHttp({
  baseUrl,
  tokenStore: api.tokenStore,
  getLocale: () => i18n.getLocale(),
})
const auth = createAdminAuth(api)
const router = createAdminRouter({ auth })

const app = createApp(App)
app.provide('api', api)
app.provide(adminAuthKey, auth)
app.provide('i18nRuntime', i18n)
app.use(i18n.i18n)
app.use(router)
app.mount('#app')
